const unitToMinutes = {
  minutes: 1,
  hours: 60,
  days: 1440,
  weeks: 10080,
  months: 43200,
  years: 525600,
};

export const calculateTotalDelay = (actions, index) => {
  let sum = 0;
  for (let i = 0; i <= index; i++) {
    const delay = actions?.[i]?.delay;
    if (delay?.value && delay?.delayUnit) {
      const factor = unitToMinutes?.[delay.delayUnit] || 0;
      sum += delay.value * factor;
    }
  }
  return sum;
};
